import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../../config/site';

const handleLinkClick = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const MerchFooter: React.FC = () => {
  return (
    <footer className="relative bg-black text-white border-t border-white/10">
      {/* Logo block, top */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14 flex flex-col items-center text-center">
          <img
            src="/insurance logos/EC logo transparent main.png"
            alt="Enhance Companies"
            className="h-16 w-auto brightness-0 invert opacity-90"
          />
          <p className="mt-6 text-[10px] uppercase tracking-[0.4em] text-neutral-gray-500">
            The Enhance Collection
          </p>
          <p className="mt-3 text-neutral-gray-400 text-sm max-w-md leading-relaxed">
            Premium apparel for the producers who set the standard.
          </p>
        </div>
      </div>

      {/* Link columns */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          {/* Shop */}
          <div>
            <h3 className="text-[10px] uppercase tracking-[0.3em] text-neutral-gray-500 mb-5">
              Shop
            </h3>
            <ul className="space-y-3">
              {[
                { to: '/store', label: 'All Pieces' },
                { to: '/store#cat-tops', label: 'Tops' },
                { to: '/store#cat-outerwear', label: 'Outerwear' },
                { to: '/store#cat-bottoms', label: 'Bottoms' },
                { to: '/store#cat-accessories', label: 'Accessories' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    onClick={handleLinkClick}
                    className="text-white/80 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-[10px] uppercase tracking-[0.3em] text-neutral-gray-500 mb-5">
              Company
            </h3>
            <ul className="space-y-3">
              {[
                { to: '/', label: 'Home' },
                { to: '/about', label: 'About' },
                { to: '/carriers', label: 'Carriers' },
                { to: '/technology', label: 'Technology' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    onClick={handleLinkClick}
                    className="text-white/80 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-[10px] uppercase tracking-[0.3em] text-neutral-gray-500 mb-5">
              Resources
            </h3>
            <ul className="space-y-3">
              {[
                { to: '/lead-catalog', label: 'Lead Catalog' },
                { to: '/agent/login', label: 'Agent Login' },
                { to: '/apply', label: 'Apply Now' },
                { to: '/for-agencies', label: 'For Agencies' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    onClick={handleLinkClick}
                    className="text-white/80 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-[10px] uppercase tracking-[0.3em] text-neutral-gray-500 mb-5">
              Contact
            </h3>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${siteConfig.contact.phone}`}
                  className="text-white/80 hover:text-white transition-colors text-sm"
                >
                  {siteConfig.contact.phone}
                </a>
              </li>
              <li className="text-white/60 text-sm">Los Angeles, CA</li>
              <li>
                <a
                  href="https://www.instagram.com/enhancecompanies/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 hover:text-white transition-colors text-sm"
                >
                  @enhancecompanies
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom strip */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-7 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] uppercase tracking-[0.25em] text-neutral-gray-500">
            © {new Date().getFullYear()} SW Capital LLC, DBA {siteConfig.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-7 text-[11px] uppercase tracking-[0.25em]">
            <Link
              to="/contact"
              onClick={handleLinkClick}
              className="text-neutral-gray-500 hover:text-white transition-colors"
            >
              Contact
            </Link>
            <Link
              to="/apply"
              onClick={handleLinkClick}
              className="text-neutral-gray-500 hover:text-white transition-colors"
            >
              Join Us
            </Link>
            <Link
              to="/privacy-policy"
              onClick={handleLinkClick}
              className="text-neutral-gray-500 hover:text-white transition-colors"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MerchFooter;
